import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  ICreatePagamento,
  ICreatePagamentoAntiFraude,
  ICreatePagamentoPix
} from './pagamento.model';

@Injectable({
  providedIn: 'root'
})
export class PagamentoService {
  constructor(private http: HttpClient) {}

  CreateTransacao(body: ICreatePagamento, guid: string): Observable<any> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}PagamentoApi/CreateTransacaoAutorizacao`,
      body,
      { headers: headers }
    );
  }

  CreatePagamentoWithAntifraude(
    body: ICreatePagamentoAntiFraude,
    guid: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}PagamentoApi/CreatePagamentoWithAntifraude`,
      body,
      { headers: headers }
    );
  }

  CreatePixTransacao(body: ICreatePagamentoPix, guid: string): Observable<any> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}PagamentoApi/CreateQrCode`,
      body,
      { headers: headers }
    );
  }

  GetTransacaoByAgendamento(id: number): Observable<any> {
    const agendamentoId = id;

    return this.http.get<any>(
      `${environment.baseURL}PagamentoApi/GetTransacaoByAgendamento?agendamentoId=${agendamentoId}`
    );
  }

  GetPagamentoIncompletoByAgendamento(id: number): Observable<any> {
    const agendamentoId = id;

    return this.http.get<any>(
      `${environment.baseURL}PagamentoApi/GetPagamentoIncompletoByAgendamento?PK_AGND=${agendamentoId}`
    );
  }
}
